import axios from 'axios';
import { store } from '../redux/store';
import { LOGOUT_USER } from '../redux/actions/index';

axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			store.dispatch({ type: LOGOUT_USER });
			localStorage.removeItem('x-auth-token');
			// Navigate to login — use window.location since we're outside React
			if (!window.location.pathname.includes('/login')) {
				window.location.href = '/login';
			}
		}
		return Promise.reject(error);
	}
);
